import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import BookingCard from "examples/Cards/BookingCard";
// import Modal from 'react-modal';

// Images
// import booking1 from "assets/images/products/product-1-min.jpg";
// import booking2 from "assets/images/products/product-2-min.jpg";
// import booking3 from "assets/images/products/product-3-min.jpg";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import { useState, useEffect } from "react";
import MDButton from "../../../../components/MDButton";
import DataTable from "../../../../examples/Tables/DataTable";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import Modal from '@mui/material/Modal';
// import Box from "@mui/material/Box";
// import Typography from "@mui/material/Typography";
// import Autocomplete from "@mui/material/Autocomplete";
// import selectData from "../../account/settings/components/BasicInfo/data/selectData";
import FormField from "../../account/components/FormField";
import MDSnackbar from "../../../../components/MDSnackbar";
import MDInput from "../../../../components/MDInput";
import { useLoadDataTable } from "./data";
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import Button from "@mui/material/Button";
import CustomService from "../../../../services/custome.service";
import validateForm from "../../../../utils";
import {modalStyle} from "../../../../components/Utils/ModalStyle";


function AmenityHoliday() {

    const [clickedItemId, setClickedItemId] = useState(0);
    const [errorMessage, setErrorMessage] = useState(false);

    const [open, setOpen] = useState(false);

    const [infoSB, setInfoSB] = useState(false);
    const [errorSB, setErrorSB] = useState(false);

    const openInfoSB = () => setInfoSB(true);
    const closeInfoSB = () => setInfoSB(false);

    const openErrorSB = () => setErrorSB(true);
    const closeErrorSB = () => setErrorSB(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [openDialog, setOpenDialog] = useState(false);
    const handleOpenDialog = () => setOpenDialog(true);
    const handleCloseDialog = () => setOpenDialog(false);
    const handleAgreeDeleteDialog = () => {
      CustomService.removeHoliday(clickedItemId)
          .then((response) =>{
              console.log(response);
              openInfoSB();
              window.location.reload();
          })
          .catch((err) => {
              console.log(err);
              setErrorMessage(err);
              openErrorSB();
          });
    };
    function handleDelete(elem) {
        handleOpenDialog();
        setClickedItemId(elem.target.id);
    }



    const [disableAction, setDisableAction] = useState(true);
    const [holidayName, setHolidayName] = useState("");
    const [holidayDate, setHolidayDate] = useState("");

    const tableData = useLoadDataTable(handleDelete);



    const [formData, setFormData] = useState({
        "holiday_name": { "validation":{is_required:true, min:3}, "error_status": false, "error_message":"", "value": ""},
        "holiday_date": { "validation":{is_required:true}, "error_status": false, "error_message":"", "value": ""},
    })
    const setValue = (source, valueOfElement) => {
        // console.log(source + " -> "+ valueOfElement);
        if(source === "holiday_name") setHolidayName(valueOfElement);
        if(source === "holiday_date") setHolidayDate(valueOfElement);
    }
    const saveDataClicked = (e) =>{
        e.preventDefault();
        console.log(holidayName + ", "+ holidayDate );
        if(!checkForm()){
            CustomService.insertHoliday(holidayDate , holidayName )
                .then((response) =>{
                    console.log(response);
                    openInfoSB();
                    window.location.reload();
                })
                .catch((err) => {
                    console.log(err);
                    setErrorMessage(err);
                    openErrorSB();
                });
        }
        handleClose();
    }
    const onChangeInput = (element, source) => {
        setDisableAction(false);
        let valueOfElement =  "";
        // console.log(element)
        if("target" in element){
            valueOfElement = element.target.value;
        }else if("id" in element) {
            valueOfElement = element.id
        }
        // console.log(valueOfElement)
        let errorObject = validateForm(formData[source]["validation"], source, valueOfElement)
        if(errorObject != null){
            setFormData(prevErrors => ({...prevErrors,
                        [source]: {
                            "validation":prevErrors[source]["validation"],
                            "error_status":errorObject["error"],
                            "error_message":errorObject["errorMessage"],
                            "value": valueOfElement}}))

        }
        setValue(source, valueOfElement);
    }
    const checkForm = () => {
        let is_check = false;
        for (const validationKey in formData) {
            let xData = validateForm(formData[validationKey]["validation"], validationKey, formData[validationKey]["value"])
            // console.log(xData)
            if(xData.error){
                is_check = true;
            }
        }
        setDisableAction(is_check);
        return is_check
    }


    const renderSB = (
        <div>
            <MDSnackbar
              color="success"
              icon="notifications"
              title="Amenity System"
              content="Your data saved successfully"
              dateTime=""
              open={infoSB}
              onClose={closeInfoSB}
              close={closeInfoSB}
            />
            <MDSnackbar
              color="error"
              icon="error"
              title="Amenity System"
              content={errorMessage}
              dateTime=""
              open={errorSB}
              onClose={closeErrorSB}
              close={closeErrorSB}
            />
        </div>
    );
    const renderModal = () => {
        return <Modal open={open} onClose={handleClose} color={"warning"} >
      <MDBox sx={modalStyle}>
        <Card id="basic-info" sx={{ overflow: "visible" }}>
          <MDBox p={3}>
            <MDTypography variant="h5">Insert Holiday</MDTypography>
          </MDBox>
          <MDBox component="form" pb={3} px={3}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12}>
                <FormField label={"Select Date"}
                            onChange={e => onChangeInput(e, "holiday_date")}
                            error={formData["holiday_date"].error_status}
                            helperText={formData["holiday_date"].error_message}
                            type={"date"}   />
              </Grid>
              <Grid item xs={12} md={12}>
                <FormField
                        onChange={e => onChangeInput(e, "holiday_name")}
                        error={formData["holiday_name"].error_status}
                        helperText={formData["holiday_name"].error_message}
                        label="Holiday Name"
                        placeholder="First Day"  />
              </Grid>
              <Grid item xs={12} md={12}>
                <MDButton color={"info"} size={"large"} onClick={saveDataClicked} >Save Data</MDButton>
              </Grid>
            </Grid>
          </MDBox>
        </Card>
      </MDBox>
    </Modal>
    };
    const renderDialog = () => {
        return (
            <Dialog
                open={openDialog}
                keepMounted
                onClose={handleCloseDialog}
                aria-describedby="alert-dialog-slide-description"
              >
                <DialogTitle><Icon color={"warning"} >warning</Icon>{" Delete confirmation"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                Are you sure to delete this item ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <MDButton onClick={handleCloseDialog} >Disagree</MDButton>
              <MDButton onClick={handleAgreeDeleteDialog}  size={"large"}  color={"info"}  >Agree</MDButton>
            </DialogActions>
          </Dialog>
        )
    }
    const renderAmenityHolidayList = () => {
        return(
            <MDBox my={3}>
              {renderSB}
              {renderModal()}
              {renderDialog()}
            <MDBox  display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
              <MDButton variant="gradient" color="info" size="large" onClick={handleOpen}>
                new Holiday
              </MDButton>
            </MDBox>
            <Card>
              <DataTable showTotalEntries={true} table={tableData} entriesPerPage={false} canSearch />
            </Card>
          </MDBox>
        )
    };

    return (
        <DashboardLayout>
          <DashboardNavbar />
            {renderAmenityHolidayList()}
          <Footer />
        </DashboardLayout>
    );
}

export default AmenityHoliday;
